:host {
    display: block;
    margin-top: 40px;

    .headline {
        @include typo-ws-paragraph;

        margin: 0;
    }

    ::slotted(a) {
        @include typo-ws-copy-l;

        margin-top: 4px;
        text-decoration: none;
        color: currentColor;
    }

    slot {
        display: block;
    }

    slot:hover {
        color: $color-white;
    }
}
